import { Button, message } from 'antd';
import { useState } from 'react';

import MindverseModal from '@/components/modal';
import TitleDescription from '@/components/title-description';
import useGenius from '@/hooks/useGenius';
import { useTranslation } from '@/i18n/client';
import { exportAllMemories } from '@/service/note';

import styles from './index.less';

export default function ExportMemories(): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  const { shadowMindId: mindId } = useGenius();
  const { t } = useTranslation();

  const handleExport = () => {
    if (!mindId) {
      message.error(t('error.oops'));

      return;
    }

    message.success(t('menu.accountSettingsModal.exportModal.successTips'));
    exportAllMemories({ mindId }).then((res) => {
      const { data } = res;

      if (data.code === 0) {
        window.open(data.data, '_blank');
        message.success(data.data);
        message.success(
          <span
            dangerouslySetInnerHTML={{
              __html: t('menu.accountSettingsModal.exportModal.linkTips', { link: data.data })
            }}
          />
        );
      }
    });
  };

  return (
    <>
      <TitleDescription
        className={styles.titleItem}
        title={t('menu.accountSettingsModal.export')}
      />
      <Button className={styles.delete} onClick={() => setOpen(true)} type="primary">
        {t('menu.accountSettingsModal.exportBtn')}
      </Button>
      <MindverseModal
        footer={[
          <Button key="cancel" onClick={() => setOpen(false)}>
            {t('common.cancel')}
          </Button>,
          <Button key="delete" onClick={() => handleExport()} type="primary">
            {t('common.export')}
          </Button>
        ]}
        onCancel={() => setOpen(false)}
        open={open}
        title={t('menu.accountSettingsModal.exportModal.title')}
        width={580}
      >
        <div className={styles.modalContainer}>
          <div>{t('menu.accountSettingsModal.exportModal.div1')}</div>
          <ul className={styles.ulContent}>
            <li>{t('menu.accountSettingsModal.exportModal.li1')}</li>
            <li>{t('menu.accountSettingsModal.exportModal.li2')}</li>
            <li>{t('menu.accountSettingsModal.exportModal.li3')}</li>
            <li>{t('menu.accountSettingsModal.exportModal.li4')}</li>
          </ul>
          <div>{t('menu.accountSettingsModal.exportModal.div2')}</div>
          <br />
          <div>{t('menu.accountSettingsModal.exportModal.div3')}</div>
        </div>
      </MindverseModal>
    </>
  );
}
